<div class="my-team-league-cell">
  <a class="link-wrapper" [href]="link">
    <img [src]="emblem" alt="Team Logo">
    <p>{{ name }}</p>
  </a>

  <ng-container *ngIf="userAlreadyFollowsTeamOrLeague; else showFollowButton">
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Mehr">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="toggleFollow(false)">
        <span>Nicht mehr folgen</span>
      </button>
    </mat-menu>
  </ng-container>

  <ng-template #showFollowButton>
    <button (click)="toggleFollow(true)"
            color="primary"
            mat-stroked-button>
      <mat-icon>favorite</mat-icon>
      Folgen
    </button>
  </ng-template>
</div>
